export const CONDITION_SHOW_RESET = 'CONDITION_SHOW_RESET'
export const CONDITION_SHOW_SET_ERROR = 'CONDITION_SHOW_SET_ERROR'
export const CONDITION_SHOW_SET_RETRIEVED = 'CONDITION_SHOW_SET_RETRIEVED'
export const CONDITION_SHOW_TOGGLE_LOADING = 'CONDITION_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/condition/show/mutation_types.js